/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import moment from 'moment';

const calculateOrgRequestBody = values => ({
  name: values.orgName,
  deactivationDate: values.deactivationDate ? moment(values.deactivationDate).utc().format() : null,
  notes: values.notes || null,
  permissions: {
    modelTypes: [...(values.standard ? [1] : []), ...(values.advanced ? [2] : [])],
    perRealization: values.allRealizations || false,
    recoveryTime: values.recoveryTime || false,
  },
});

export default calculateOrgRequestBody;
